import Component from "../abstracts/Component";

export default class DropdownComponent extends Component {
  bindEvents() {
    // Utilities dropdown : cart, checkout, my account mobile navigation
    $(document).on("click", ".utility-box-title", function(event) {
      event.stopPropagation();
      event.preventDefault();
      // open dorpdown only if faq elements are > 1
      if (
        $(".faq-subsection").length >= 1 ||
        $(".sizes-subsection").length >= 1
      ) {
        $(this).toggleClass("open");
        $(this)
          .next("div")
          .stop(true, false)
          .slideToggle();

        //closes other dropdown(s) when a new one is opened
        if ($(".sizes-subsection").length >= 1) {
          let contents = document.querySelectorAll(".utility-box-title");
          contents.forEach(function(content) {
            if (
              $(content).hasClass("selected") &&
              $(content).hasClass("open")
            ) {
              $(content)
                .toggleClass("open")
                .removeClass("selected")
                .attr("aria-expanded", "false");
              $(content)
                .next("div")
                .stop(true, false)
                .slideToggle();
              $(content)
                .find("span")
                .removeClass("icon-chevron-up");
            }
          });
          $(this).toggleClass("selected");
          $(this).attr("aria-expanded", $(this).hasClass("open"));
          $(this)[0].focus();
        }

        if (
          !$(this)
            .find("span")
            .hasClass("icon-chevron-up")
        ) {
          $(this)
            .find("span")
            .addClass("icon-chevron-up");
        } else {
          $(this)
            .find("span")
            .removeClass("icon-chevron-up");
        }
      }
    });

    $(document).on("click", ".ctaDisplayForm", function(event) {
      event.stopPropagation();
      event.preventDefault();
      // open dorpdown only if faq elements are > 1

      console.log($(".form-contact-box"));
      $(".form-contact-box").toggleClass("open");
      $(".form-contact-box")
        .next("div")
        .stop(true, false)
        .slideToggle();
      if (!$(".form-contact-box").hasClass("open")) {
        let ctaOpen = document.querySelectorAll(".ctaDisplayForm")[0];
        ctaOpen.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center"
        });
      }
    });
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
